import AddressInfoModel from "./address-info";
import CreditCardInfoModel from "./credit-card-info";

export default class GatewaySubscriptionDetailsAuthnetModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.subscription_id = model.subscription_id ? model.subscription_id : '';
        this.customer_profile_id = model.customer_profile_id ? model.customer_profile_id : '';
        this.customer_payment_profile_id = model.customer_payment_profile_id ? model.customer_payment_profile_id : '';
        this.customer_address_id = model.customer_address_id ? model.customer_address_id : '';

        this.credit_card_info = new CreditCardInfoModel(model.credit_card_info);
        this.billing_info = new AddressInfoModel(model.billing_info);
        this.shipping_info = new AddressInfoModel(model.shipping_info);
    }

}
